import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';

const UploadProgress = (props) => {
  const { uploads, error, detailPath } = props;

  return (
    <Card>
      <CardHeader title="Uploading" />
      <Divider />
      <CardContent>
        <Stack spacing={2}>
          {uploads.map((upload) => (
            <Box key={upload.key}>
              <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                <Typography variant="body2">{upload.label}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {upload.status}
                </Typography>
              </Stack>
              <LinearProgress
                variant={upload.progress === null ? 'indeterminate' : 'determinate'}
                value={upload.progress || 0}
                color={upload.failed ? 'error' : 'primary'}
              />
            </Box>
          ))}

          {error && (
            <Alert severity="error">
              <AlertTitle>{error.message}</AlertTitle>
              {detailPath ? (
                <>
                  <Typography variant="body2" gutterBottom>
                    The package row was created, but its artifact did not finish
                    uploading. The package exists as a draft with nothing behind it —
                    nothing is published, and nothing is lost.
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    Open the package and use <strong>Verify</strong> to confirm what is
                    missing, then <strong>Re-upload artifact</strong> to finish the job.
                  </Typography>
                  <Button component={RouterLink} to={detailPath} size="small">
                    Open the package
                  </Button>
                </>
              ) : (
                <Typography variant="body2">
                  Nothing was created — the registration itself failed, so you can fix
                  the form and try again.
                </Typography>
              )}
            </Alert>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

UploadProgress.propTypes = {
  detailPath: PropTypes.string,
  error: PropTypes.object,
  uploads: PropTypes.array.isRequired,
};

export default UploadProgress;
